var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"tabs flex flex-align-center flex-justify-between"},_vm._l((_vm.editmsg.menuList),function(v,i){return _c('div',{key:i,staticClass:"demo",class:{choose:_vm.index==i},on:{"click":function($event){return _vm.tap(i)}}},[_vm._v(_vm._s(v.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }